import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useBrand } from '../../../BrandContext';
import { ObRedirectSpinner } from '../../../pages/Spinner';
import { useObStartData } from '../../../data/data';
import { useAggregatorConsumerName } from '../../../utilities/aggregatorConsumerNameProvider';
import { addNewRelicPageAction } from '../../../utilities/newRelic';
import ErrorContext from '../../../utilities/errorContext';
import { isAggregatorConsumer, isApiPartner } from '../../../utilities/utils';
import { safeNavigate } from '../../../utilities/safeNavigate';

export const getQuotationToken = (agreementUrl: any) => {
    if (!agreementUrl) return undefined;
    try {
        return new URL(agreementUrl).searchParams.get('quotation') ?? undefined;
    } catch {
        return undefined;
    }
};

const getPcr = (pcr: any, brand: any, aggregatorConsumerName: any) => {
    if (!isAggregatorConsumer(aggregatorConsumerName) && !isApiPartner(brand)) return undefined;
    return pcr || undefined;
};

const getObStartParams = ({ agreementUrl, ccsCode, sParameter, pcr, brand, aggregatorConsumerName }: any) => {
    const resolvedPcr = getPcr(pcr, brand, aggregatorConsumerName);
    const s = isApiPartner(brand) ? sParameter : undefined;

    return {
        quotation: getQuotationToken(agreementUrl),
        ...(ccsCode && { productCode: ccsCode }),
        ...(resolvedPcr && { pcr: resolvedPcr }),
        ...(s && { s })
    };
};

const ObStartRequest = ({ params, agreementUrl }: any) => {
    const [data, , { error }] = useObStartData(params);

    const connectionUrl = data?.connectionUrl;

    React.useEffect(() => {
        if (connectionUrl) {
            // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
            addNewRelicPageAction('OB Journey 1 Accept - Redirecting to provider');
            safeNavigate(connectionUrl);
        } else if (error) {
            // @ts-expect-error TS2554: Expected 2 arguments, but got 1.
            addNewRelicPageAction('OB Journey 1 Accept - ob-start failed, redirecting to agreement');
            window.location.assign(agreementUrl);
        }
    }, [connectionUrl, error, agreementUrl]);

    return <ObRedirectSpinner agreementUrl={agreementUrl} />;
};

ObStartRequest.propTypes = {
    params: PropTypes.object.isRequired,
    agreementUrl: PropTypes.string.isRequired
};

const ObStartRedirect = ({ agreementUrl = '', ccsCode = '', sParameter = '', pcr = '' }) => {
    const brand = useBrand();
    // @ts-expect-error TS2488: Type '{}' must have a '[Symbol.iterator]()' method that returns an iterator.
    const [aggregatorConsumerName] = useAggregatorConsumerName();
    // @ts-expect-error TS2339: Property 'setError' does not exist on type '{}'.
    const { setError } = useContext(ErrorContext);

    const params = getObStartParams({ agreementUrl, ccsCode, sParameter, pcr, brand, aggregatorConsumerName });

    React.useEffect(() => {
        if (!params.quotation) setError();
    }, [params.quotation, setError]);

    if (!params.quotation) return null;

    return <ObStartRequest params={params} agreementUrl={agreementUrl} />;
};

ObStartRedirect.propTypes = {
    agreementUrl: PropTypes.string,
    ccsCode: PropTypes.string,
    sParameter: PropTypes.string,
    pcr: PropTypes.string
};

export default ObStartRedirect;
